const images = {
    delivery: require('../assets/images/delivery.jpeg'),
};

export default images;